import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { Box, Card, Image } from "@chakra-ui/react";
import { useState } from "react";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";

import ModalGallery from "./ModalGallery";

const GallerySlide = ({ images, koppi, setIsRouteViewer }) => {
    const [idx, setIdx] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = () => {
        setIsOpen(true);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const handleOpenModal = (idx) => {
        setIdx(idx);
        onOpen();
    };

    return (
        images && (
            <Box w="full" mx="auto" py={4}>
                <ModalGallery
                    isOpen={isOpen}
                    onClose={onClose}
                    data={images}
                    idx={idx}
                    setIdx={setIdx}
                />
                <Swiper
                    modules={[Pagination, EffectFade, Autoplay]}
                    effect="fade"
                    spaceBetween={10}
                    slidesPerView={1}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: true,
                    }}
                    loop
                >
                    {images.map((image, idx) => {
                        return (
                            <SwiperSlide key={idx}>
                                <Card.Root
                                    borderRadius="lg"
                                    overflow="hidden"
                                    boxShadow="sm"
                                    w="100%"
                                    h="450px"
                                >
                                    <Card.Body
                                        position="relative"
                                        bgImage={wrapBgImage(image.url)}
                                        bgSize="cover"
                                        bgPosition="center top"
                                        bgRepeat="no-repeat"
                                        justifyContent="center"
                                        zIndex={0}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleOpenModal(idx);
                                        }}
                                    >
                                        {koppi?.status === "ACTIVE" && (
                                            <Box
                                                position="absolute"
                                                bottom={3}
                                                left={3}
                                                display="flex"
                                                gap={3}
                                                p={3}
                                                bg="#000000"
                                                w="fit-content"
                                                borderWidth={2}
                                                borderRadius="lg"
                                                borderColor="#FFFFFF"
                                                color="#FFFFFF"
                                                zIndex={1}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsRouteViewer(true);
                                                }}
                                            >
                                                <Image
                                                    src="https://media.grupoguia.mx/assets/icons/gallery_virtual_route.svg"
                                                    alt="virtual_route"
                                                    maxW="30px"
                                                />
                                                Ver recorrido virtual
                                            </Box>
                                        )}
                                        <Box
                                            position="absolute"
                                            bottom={3}
                                            right={3}
                                            display="flex"
                                            gap={3}
                                            py={3}
                                            px={6}
                                            bg="#000000"
                                            w="fit-content"
                                            borderWidth={2}
                                            borderRadius="lg"
                                            borderColor="#FFFFFF"
                                            color="#FFFFFF"
                                        >
                                            {`${idx + 1} / ${images.length}`}
                                        </Box>
                                    </Card.Body>
                                </Card.Root>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Box>
        )
    );
};

export default GallerySlide;
